<header
    class="header-area bg-white border-bottom-radius box-shadow"
    [ngClass]="{ active: isToggled }"
>
    <div class="header-shell d-md-flex align-items-center justify-content-space-between">
        <div class="header-left-side d-flex align-items-center">
            <a routerLink="/" class="logo d-flex align-items-center text-decoration-none">
                <img src="img/logo.png" alt="VCCI Logo" class="brand-icon" />
            </a>
            <div class="search-box position-relative">
                <input
                    type="text"
                    class="input-search"
                    [placeholder]="'common.searchItems' | translate"
                />
                <button type="button">
                    <i class="ri-search-line"></i>
                </button>
            </div>
        </div>
        <ul class="header-right-side d-flex align-items-center mt-0 mb-0">
            <!-- Language Selector -->
            <li class="language-wrap position-relative">
                <button
                    mat-icon-button
                    type="button"
                    [matMenuTriggerFor]="languageMenu"
                    class="language-btn"
                    [attr.aria-label]="'header.language' | translate"
                >
                    <span class="language-btn__inner">
                        <span class="language-btn__icon-bg"></span>
                        <img [src]="currentLanguageFlag" [alt]="currentLanguage" class="language-btn__flag" />
                        <span class="language-btn__chevron">
                            <i class="ri-arrow-down-s-line"></i>
                        </span>
                    </span>
                    <span class="language-btn__glow"></span>
                </button>
                <mat-menu class="language-menu-dropdown" #languageMenu="matMenu" xPosition="after">
                    <ul class="header-dropdown-list m-0">
                        <li>
                            <button
                                type="button"
                                class="header-dropdown-item"
                                [class.header-dropdown-item--active]="isCurrentLanguage('en')"
                                (click)="changeLanguage('en')"
                            >
                                <img src="img/flags/en.png" alt="" class="header-dropdown-item__flag" width="22" height="22" />
                                <span class="header-dropdown-item__label">English</span>
                                @if (isCurrentLanguage('en')) {
                                    <i class="ri-check-line header-dropdown-item__check" aria-hidden="true"></i>
                                }
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                class="header-dropdown-item"
                                [class.header-dropdown-item--active]="isCurrentLanguage('vi')"
                                (click)="changeLanguage('vi')"
                            >
                                <img src="img/flags/vi.png" alt="" class="header-dropdown-item__flag" width="22" height="22" />
                                <span class="header-dropdown-item__label">Vietnamese</span>
                                @if (isCurrentLanguage('vi')) {
                                    <i class="ri-check-line header-dropdown-item__check" aria-hidden="true"></i>
                                }
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                class="header-dropdown-item"
                                [class.header-dropdown-item--active]="isCurrentLanguage('kr')"
                                (click)="changeLanguage('kr')"
                            >
                                <img src="img/flags/kr.png" alt="" class="header-dropdown-item__flag" width="22" height="22" />
                                <span class="header-dropdown-item__label">Korean</span>
                                @if (isCurrentLanguage('kr')) {
                                    <i class="ri-check-line header-dropdown-item__check" aria-hidden="true"></i>
                                }
                            </button>
                        </li>
                    </ul>
                </mat-menu>
            </li>

            <!-- Chat Button -->
            <li class="chat-wrap position-relative">
                <a
                    routerLink="/chat"
                    mat-icon-button
                    type="button"
                    class="chat-btn"
                    [class.chat-btn--active]="isChatActive"
                    [attr.aria-label]="'header.chat' | translate"
                >
                    <span class="chat-btn__inner">
                        <span class="chat-btn__icon-bg"></span>
                        <i class="chat-btn__icon ri-wechat-2-fill"></i>
                        @if (chatUnreadCount() > 0) {
                            <span class="chat-btn__badge">
                                {{ chatUnreadCount() > 99 ? '99+' : chatUnreadCount() }}
                            </span>
                        }
                    </span>
                    <span class="chat-btn__glow"></span>
                </a>
            </li>

            <!-- Notification Bell -->
            <li class="notification-wrap position-relative">
                <button
                    mat-icon-button
                    type="button"
                    class="notification-btn"
                    [class.notification-btn--active]="showNotificationPanel"
                    (click)="toggleNotificationPanel()"
                    [attr.aria-label]="'header.notifications.ariaLabel' | translate"
                    [attr.aria-expanded]="showNotificationPanel"
                    aria-haspopup="true"
                >
                    <span class="notification-btn__inner">
                        <span class="notification-btn__icon-bg"></span>
                        <i class="notification-btn__icon ri-notification-3-fill"></i>
                        @if (notificationService.unreadCount() > 0) {
                            <span class="notification-btn__badge">
                                {{ notificationService.unreadCount() > 99 ? '99+' : notificationService.unreadCount() }}
                            </span>
                        }
                    </span>
                    <span class="notification-btn__glow"></span>
                </button>
                @if (showNotificationPanel) {
                    <div
                        class="notification-dropdown"
                        role="dialog"
                        [attr.aria-label]="'header.notifications.title' | translate"
                    >
                        <div class="notification-dropdown__hero">
                            <div class="notification-dropdown__hero-text">
                                <h3 class="notification-dropdown__title">
                                    {{ 'header.notifications.title' | translate }}
                                </h3>
                                @if (notificationService.unreadCount() > 0) {
                                    <span class="notification-dropdown__unread-pill">
                                        {{ 'header.notifications.unreadBadge' | translate: { count: notificationService.unreadCount() } }}
                                    </span>
                                }
                            </div>
                            <button
                                type="button"
                                class="notification-dropdown__mark-all"
                                [disabled]="notificationService.unreadCount() === 0"
                                (click)="markAllRead($event)"
                            >
                                <i class="ri-check-double-line" aria-hidden="true"></i>
                                <span>{{ 'header.notifications.markAllRead' | translate }}</span>
                            </button>
                        </div>

                        <div class="notification-dropdown__body">
                            @if (notificationInbox.length === 0) {
                                <div class="notification-dropdown__empty">
                                    <div class="notification-dropdown__empty-icon" aria-hidden="true">
                                        <mat-icon>notifications_off</mat-icon>
                                    </div>
                                    <div class="notification-dropdown__empty-title">
                                        {{ 'header.notifications.emptyTitle' | translate }}
                                    </div>
                                    <div class="notification-dropdown__empty-subtitle">
                                        {{ 'header.notifications.emptySubtitle' | translate }}
                                    </div>
                                </div>
                            } @else {
                                <ul class="notification-list m-0 list-unstyled">
                                    @for (item of notificationInbox; track item.id) {
                                        <li>
                                            <button
                                                type="button"
                                                class="notification-item"
                                                [class.notification-item--unread]="item.readStatus === 'UNREAD'"
                                                (click)="openNotification(item)"
                                            >
                                                <span
                                                    class="notification-item__icon"
                                                    [ngClass]="notificationIconClass(item.type)"
                                                    aria-hidden="true"
                                                >
                                                    <mat-icon>{{ notificationIcon(item.type) }}</mat-icon>
                                                </span>
                                                <span class="notification-item__body">
                                                    <span class="notification-item__title">
                                                        {{ item.title ?? ('header.notifications.title' | translate) }}
                                                    </span>
                                                    @if (item.content) {
                                                        <span class="notification-item__content">{{ item.content }}</span>
                                                    }
                                                    <span class="notification-item__time">
                                                        <i class="ri-time-line" aria-hidden="true"></i>
                                                        {{ relativeTime(item.createdDate) }}
                                                    </span>
                                                </span>
                                                @if (item.readStatus === 'UNREAD') {
                                                    <span
                                                        class="notification-item__dot"
                                                        [attr.aria-label]="'header.notifications.newDot' | translate"
                                                    ></span>
                                                }
                                            </button>
                                        </li>
                                    }
                                </ul>
                            }
                        </div>

                        <div class="notification-dropdown__footer">
                            <a
                                routerLink="/notification-management"
                                class="notification-dropdown__view-all"
                                (click)="showNotificationPanel = false"
                            >
                                <span>{{ 'header.notifications.viewAll' | translate }}</span>
                                <i class="ri-arrow-right-line" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                }
            </li>

            <li>
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="profileMenu"
                    class="profile-btn main-color border-none bg-transparent position-relative name-display"
                >
                    @if (hasAvatar()) {
                        <img
                            [src]="getAvatarUrl()"
                            class="rounded-circle avatar-img"
                            alt="avatar"
                            loading="lazy"
                            fetchpriority="low"
                            (error)="onAvatarError()"
                        />
                    }
                    @if (!hasAvatar()) {
                        <div class="avatar-placeholder rounded-circle">
                            {{ getAvatarInitial() }}
                        </div>
                    }
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <div class="profile-menu">
                        <div class="profile-menu__hero">
                            <div class="profile-menu__hero-avatar" aria-hidden="true">
                                @if (hasAvatar()) {
                                    <img
                                        [src]="getAvatarUrl()"
                                        class="profile-menu__hero-img"
                                        alt=""
                                        loading="lazy"
                                        (error)="onAvatarError()"
                                    />
                                } @else {
                                    <div class="profile-menu__hero-placeholder">
                                        {{ getAvatarInitial() }}
                                    </div>
                                }
                            </div>
                            <div class="profile-menu__hero-text">
                                <div class="profile-menu__name">{{ getFullName() }}</div>
                                @if (getDepartmentName()) {
                                    <div class="profile-menu__dept">{{ getDepartmentName() }}</div>
                                }
                                <div class="profile-menu__role">{{ getUserRoleTranslationKey() | translate }}</div>
                            </div>
                        </div>
                        <div class="profile-menu__divider" role="separator"></div>
                        <ul class="profile-menu__list m-0 list-unstyled">
                            @if (canShowCompanyProfile()) {
                                <li>
                                    <a
                                        routerLink="/company-profile"
                                        class="header-dropdown-item header-dropdown-item--link profile-menu__item profile-menu__item--profile"
                                    >
                                        <i class="ri-user-3-line header-dropdown-item__icon" aria-hidden="true"></i>
                                        <span class="header-dropdown-item__label">{{ 'header.profile' | translate }}</span>
                                    </a>
                                </li>
                            }
                            @if (canShowStaffProfile()) {
                                <li>
                                    <a
                                        routerLink="/staff-profile"
                                        class="header-dropdown-item header-dropdown-item--link profile-menu__item profile-menu__item--profile"
                                    >
                                        <i class="ri-user-3-line header-dropdown-item__icon" aria-hidden="true"></i>
                                        <span class="header-dropdown-item__label">{{ 'header.staffProfile' | translate }}</span>
                                    </a>
                                </li>
                            }
                            <li>
                                <button
                                    type="button"
                                    class="header-dropdown-item header-dropdown-item--btn profile-menu__item profile-menu__item--security"
                                    (click)="openChangePasswordDialog()"
                                >
                                    <i class="ri-lock-2-line header-dropdown-item__icon" aria-hidden="true"></i>
                                    <span class="header-dropdown-item__label">{{ 'header.accountSecurity' | translate }}</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    class="header-dropdown-item header-dropdown-item--btn profile-menu__item profile-menu__item--logout"
                                    (click)="logout()"
                                >
                                    <i class="ri-shut-down-line header-dropdown-item__icon" aria-hidden="true"></i>
                                    <span class="header-dropdown-item__label">{{ 'header.logout' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </mat-menu>
            </li>
        </ul>
    </div>
</header>
